<script setup lang="ts">
import "./style.css"
import { cn, hexToRgb } from "@/lib/utils"
import Circles from "./Circles.vue"
import { useBackgroundStore } from "@/components/af/Background/background.store"
import { useRoute } from "vue-router"
import { hexToHSL } from "@/lib/utils"
import { watch, ref, computed } from "vue"

const { setConfetti } = useBackgroundStore()
const route = useRoute()
const pathname = ref(route.path)

setConfetti()

const style = {
  "--af-gradient-start": hexToHSL("#ff2f92"),
  "--af-gradient-end": hexToHSL("#f59f00"),
  "--af-gradient-start-rgb": "255, 47, 146",
  "--af-gradient-end-rgb": "245, 159, 0",
  "--af-branding-cta": "#ff2f92",
  "--af-branding-cta-hover": `hsl(${hexToHSL("#e6006d", {
    lightness: -10,
  })})`,
  "--af-gradient-start-rgb-10": `rgba(${hexToRgb("#ff2f92", 0.1)})`,
  "--af-gradient-end-rgb-10": `rgba(${hexToRgb("#f59f00", 0.1)})`,
  "--af-gradient-start-rgb-20": `rgba(${hexToRgb("#ff2f92", 0.2)})`,
  "--af-gradient-end-rgb-20": `rgba(${hexToRgb("#f59f00", 0.2)})`,
  "--af-gradient-start-rgb-30": `rgba(${hexToRgb("#ff2f92", 0.3)})`,
  "--af-gradient-end-rgb-30": `rgba(${hexToRgb("#f59f00", 0.3)})`,
  "--af-gradient-start-rgb-50": `rgba(${hexToRgb("#ff2f92", 0.5)})`,
  "--af-gradient-end-rgb-50": `rgba(${hexToRgb("#f59f00", 0.5)})`,
  "--af-gradient-start-rgb-65": `rgba(${hexToRgb("#ff2f92", 0.65)})`,
  "--af-gradient-end-rgb-65": `rgba(${hexToRgb("#f59f00", 0.65)})`,
}

const hasStyle = computed(() => pathname.value.startsWith("/transition"))

watch(
  () => route.path,
  (newPath) => {
    pathname.value = newPath
  }
)
</script>

<template>
  <div
    :class="cn('background-gradient fixed -z-10 h-full w-full overflow-hidden')"
    :style="hasStyle ? style : null"
  >
    <Circles :size="800" class="absolute bottom-1/2 right-2/3 opacity-40" />
    <Circles :size="200" class="absolute bottom-0 right-10 opacity-40" />
    <Circles :size="100" class="absolute bottom-0 left-1/4 opacity-15" />
  </div>
</template>

<style scoped>
.background-gradient::before {
  z-index: -1;
  content: "";
  position: absolute;
  inset-block: 0;
  inset-inline-start: 50%;
  transform: translateX(-50%) rotate(10deg);
  border-radius: 65%;
  border: 4px solid white;
  width: 65%;
  filter: blur(50px);
  color: var(--af-gradient-start);
  background: linear-gradient(
    90deg,
    hsla(var(--af-gradient-start), 0.2) 0%,
    hsla(var(--af-gradient-end), 0.2) 100%
  );
}
</style>
